import type { ReactNode } from 'react';

interface JobMarkerProps {
  lat?: number;
  lng?: number;
  onClick?: () => void;
  children?: ReactNode;
}

export const JobMarker = ({
  onClick,
  children,
}: JobMarkerProps): JSX.Element => {
  return <a onClick={onClick}>{children}</a>;
};
